export const articleArtwork: {
  [slug: string]: { image: string; alt: string }
} = require("./article-artwork.json")
